const DEFAULT_TTL = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

export const setWithExpiry = (key, value, ttl = DEFAULT_TTL) => {
  const item = {
    value: value,
    expiry: new Date().getTime() + ttl,
  };

  console.log("Setting item:", item);
  sessionStorage.setItem(key, JSON.stringify(item));
};

export const getWithExpiry = (key) => {
  const itemStr = sessionStorage.getItem(key);

  if (!itemStr) {
    return null;
  }

  const item = JSON.parse(itemStr);
  const now = new Date().getTime();

  if (now > item.expiry) {
    sessionStorage.removeItem(key);
    return null;
  }

  return item.value;
};
